module.exports = __webpack_public_path__ + "1cd51719a1aea73c2ee3f8cf345fd24b.png";